<template>
    <vFlowVoucherComponent :postList="postList" v-if="flag"></vFlowVoucherComponent>
</template>
<script>
import vFlowVoucherComponent from '../../listComponent/basicdata/flowVoucher/flowVoucherComponent.vue';
export default {
    name: 'account',
    components: {
        vFlowVoucherComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                status: true,
                source_account_rid: true,
                web_code: true,
                remark: true,
                parameter: true,
                data_composition: true,
                username: true,
                url: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                uploadBtn: true,
                setBtn: true,
                province_rid: true,
                person_rid: true,
                description: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>